/**
 * Gates the whole app behind authentication (Req 13.1: no unauthenticated data path). While the
 * OIDC library is resolving a session or processing a redirect callback, a loading state is shown;
 * on error, a retry is offered; when unauthenticated, a Sign in screen is shown; only an
 * authenticated user sees the app.
 */

import type { ReactNode } from 'react';
import { useAuth } from 'react-oidc-context';

export interface AuthGuardProps {
  children: ReactNode;
}

function CenteredCard({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="auth-screen">
      <div className="auth-card">{children}</div>
    </div>
  );
}

export function AuthGuard({ children }: AuthGuardProps): JSX.Element {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <CenteredCard>
        <p role="status">Signing in…</p>
      </CenteredCard>
    );
  }

  if (auth.error) {
    return (
      <CenteredCard>
        <h1>Sign in failed</h1>
        <p className="auth-error">{auth.error.message}</p>
        <button type="button" onClick={() => void auth.signinRedirect()}>
          Try again
        </button>
      </CenteredCard>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <CenteredCard>
        <h1>Soroush</h1>
        <p>Sign in to view your monitoring dashboard.</p>
        <button type="button" onClick={() => void auth.signinRedirect()}>
          Sign in
        </button>
      </CenteredCard>
    );
  }

  return <>{children}</>;
}
